import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContent } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarItems } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VContent,[_c(VToolbar,{staticStyle:{"top":"64px"},attrs:{"fixed":"","id":"project-toolbar"}},[_c(VToolbarTitle,[_vm._v(_vm._s(_vm.project.title))]),_c(VSpacer),_c(VToolbarItems,{},[_c(VBtn,{attrs:{"flat":"","to":{name: 'project-index', params: {projectId: _vm.project.id}}}},[_vm._v("トップ")]),_c(VSelect,{attrs:{"items":_vm.collections,"label":"コレクションに移動","item-text":"title","item-value":"id","outlined":""},on:{"change":_vm.jumpToCollection}})],1)],1),_c('router-view',{attrs:{"project":_vm.project,"collections":_vm.collections}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }